import React, { useState, useEffect } from "react";
import { filtersPublicity, getListPublicity } from "../../interpreter/publicity";
import { FaSearch, FaFilter } from "react-icons/fa";

const PublicityFilter = ({ setPublicity, getPublicityAll }) => {
    const [searchData, setSearchData] = useState({
        commercialName: "",
        category: "",
    });

    const [categories, setCategories] = useState([]);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

    const fetchCategories = async () => {
        const data = await getListPublicity();
        setCategories(data);
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleInputChange = (e) => {
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
    };

    const handleSearch = async () => {
        try {
            const filters = {
                parameter: searchData.commercialName || "",
                category: searchData.category || ""
            };

            let data;
            if (Object.values(filters).every(value => value === "")) {
                // Si no hay filtros, obtener todas las publicidades
                data = await getPublicityAll();
            } else {
                // Aplicar filtros
                data = await filtersPublicity(filters);
            }

            if (data && Array.isArray(data)) {
                setPublicity(data);
            } else {
                setPublicity([]);
            }
        } catch (error) {
            setPublicity([]);
        }
    };

    return (
        <div className="bg-white p-4 shadow-md rounded-lg mb-4">
            <h3 className="text-lg font-semibold mb-2 text-left">Buscador de Publicidades</h3>

            <div className="flex items-center gap-2">
                <input
                    type="text"
                    name="commercialName"
                    placeholder="Buscar por nombre comercial..."
                    value={searchData.commercialName}
                    onChange={handleInputChange}
                    className="border p-2 rounded w-full h-8"
                />

                <button
                    onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                    className="w-10 bg-gray-200 hover:bg-gray-300 h-10 items-center justify-center rounded"
                >
                    <FaFilter size={20} />
                </button>
                <button
                    onClick={handleSearch}
                    className="bg-blue-600 text-white rounded hover:bg-blue-500 flex items-center justify-center w-10 h-10"
                >
                    <FaSearch className="mr-2" />
                </button>
            </div>

            {showAdvancedFilters && (
                <div className="grid grid-cols-2 gap-4 mt-3">
                    <select
                        name="category"
                        value={searchData.category}
                        onChange={handleInputChange}
                        className="border p-2 rounded w-full col-span-2"
                    >
                        <option value="">Selecciona una categoría</option>
                        {categories.map((cat) => (
                            <option key={cat.id} value={cat.code}>{cat.description}</option>
                        ))}
                    </select>
                </div>
            )}


        </div>
    );
};

export default PublicityFilter;
